import React from "react";
import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { Check, X } from "react-feather";

export default function Linklist(props) {
  return (
    <Row className="my-6">
      {props.doText && (
        <Col md={{ span: 6 }} className="d-flex align-items-stretch">
          <div className="dodont dodont-do p-3 my-2">
            {props.doTag && (
              <div className="d-flex align-items-center">
                <div className="dodont-icon">
                  <Check stroke="#00ADBA" size="24" />{" "}
                </div>
                <h3 className="h5 mb-0">{props.doTag}</h3>{" "}
              </div>
            )}
            <p className="mb-0 dodont-content">{props.doText}</p>
          </div>
        </Col>
      )}
      {props.dontText && (
        <Col md={{ span: 6 }} className="d-flex align-items-stretch">
          <div className="dodont dodont-dont p-3 my-2">
            {props.dontTag && (
              <div className="d-flex align-items-center">
                <div className="dodont-icon">
                  <X stroke="#C90B1C" size="24" />
                </div>
                <h3 className="h5 mb-0">{props.dontTag}</h3>
              </div>
            )}
            <p className="mb-0 dodont-content">{props.dontText}</p>
          </div>
        </Col>
      )}
    </Row>
  );
}

Linklist.propTypes = {
  doTag: PropTypes.string,
  doText: PropTypes.string,
  dontTag: PropTypes.string,
  dontText: PropTypes.string,
};
